import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

const STABLING_ENTRIES_WIDTH = 460;
const NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_MOBILE_VIEW_FOR_TRAINER = 224;
const NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_MOBILE_VIEW_FOR_SECRETARY = 288;
const NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_SMALL_MOBILE_VIEW_FOR_SECRETARY = 280;

export default makeStyles((theme: MuiTheme) => ({
  section: {
    padding: 0,
    borderTop: "1px solid #d7d7d7",
    boxShadow: "none",
    "&:nth-child(even)": {
      background: "#f6f6f6",
      "&$reviewSectionStables": {
        background: theme.palette.common.white
      }
    },
    "& .MuiCollapse-root": {
      paddingBottom: 12,
      [theme.breakpoints.up("md")]: {
        paddingBottom: 0
      },
      "&.MuiCollapse-hidden": {
        padding: 0
      },
      [theme.breakpoints.up("md")]: {
        paddingBottom: 24
      }
    },
    [theme.breakpoints.up("md")]: {
      "&:first-child": {
        borderTop: "none"
      },
      paddingLeft: 24
    }
  },
  sectionHeader: {
    height: 64,
    "&$sectionHeaderExpanded": {
      borderBottomColor: "transparent"
    },
    [theme.breakpoints.up("md")]: {
      height: 55,
      paddingTop: 10,
      paddingLeft: 0
    }
  },
  sectionHeaderExpanded: {},
  sectionHeaderContent: {
    alignItems: "center",
    fontSize: 16,
    [theme.breakpoints.up("md")]: {
      height: 45
    }
  },
  field: {
    flex: "0 100%"
  },
  reviewSectionDetails: {
    padding: 0,
    "& $sectionHeader": {
      [theme.breakpoints.up("md")]: {
        paddingLeft: 16
      }
    },
    [theme.breakpoints.up("md")]: {
      flex: 1
    }
  },
  reviewSectionStables: {
    padding: 0,
    background: theme.palette.common.white,
    borderTop: "none",
    "& $sectionHeader": {
      background: theme.palette.common.white,
      paddingLeft: 16
    },
    "& $fieldsGroup": {
      padding: 0
    },
    [theme.breakpoints.up("md")]: {
      flex: 1,
      maxWidth: STABLING_ENTRIES_WIDTH,
      borderLeft: `1px solid ${theme.palette.divider}`
    }
  },
  columnStables: {
    maxWidth: "100%",
    borderLeft: "none"
  },
  noPaddings: {
    padding: 0
  },
  preview: {
    flex: 1,
    display: "flex",
    [theme.breakpoints.down("sx")]: {
      flexDirection: "column",
      height: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_MOBILE_VIEW_FOR_TRAINER}px)`,
      overflowY: "auto"
    }
  },
  previewSecretary: {
    [theme.breakpoints.down("sx")]: {
      height: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_MOBILE_VIEW_FOR_SECRETARY}px)`
    },
    [theme.breakpoints.down("xs")]: {
      height: `calc(100dvh - ${NON_SCROLLABLE_ELEMENTS_HEIGHT_OF_SMALL_MOBILE_VIEW_FOR_SECRETARY}px)`
    }
  },
  column: {
    flexDirection: "column",
    borderRight: `1px solid ${theme.palette.divider}`
  },
  applicationPreview: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0
  },
  previewGroup: {
    display: "flex",
    flex: "auto",
    flexDirection: "column"
  },
  previewGroupTitle: {
    display: "flex",
    alignItems: "center",
    margin: 0,
    fontSize: 13,
    height: 46,
    color: "rgba(72, 155, 119, 1)",
    padding: "0 16px",
    borderBottom: "1px solid #eeeeee"
  },
  previewGroupList: {
    display: "flex",
    flexDirection: "column"
  },
  previewRow: {
    display: "flex",
    fontSize: 12,
    minHeight: 32,
    alignItems: "center",
    padding: "4px 22px",
    margin: 0,
    borderBottom: "1px solid #eeeeee",
    "& > span:first-child": {
      width: 114,
      minWidth: 114
    },
    "&:nth-child(odd)": {
      background: "#f7f7f7"
    }
  },
  previewRowValue: {
    display: "flex",
    flexDirection: "column",
    wordBreak: "break-all",
    "& > span": {
      lineHeight: "14px"
    }
  },
  stableEntriesPreview: {
    display: "flex",
    gap: 20,
    flexWrap: "wrap",
    "& .MuiFormHelperText-root": {
      fontSize: 11,
      marginLeft: 0
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: 0,
      paddingRight: 20
    }
  },
  stablingEntryTableHeadRow: {
    background: theme.palette.common.white,
    borderBottom: "1px solid #eeeeee",
    "& $stablingEntryTableCell": {
      padding: "4px 0px 4px 16px",
      color: theme.palette.primary.dark
    }
  },
  stablingEntryTableRow: {
    borderBottom: "1px solid #eeeeee",
    background: theme.palette.common.white,
    "&:nth-child(even)": {
      background: "#f7f7f7"
    }
  },
  stablingEntryTableCell: {
    padding: "7px 0px 7px 16px",
    color: theme.palette.common.black,
    fontSize: 12,
    "&:first-child": {
      width: 32
    }
  }
}));
